<div class="modal-panel side-panel-modal-form">
  <modal-panel id="weather-risk-modal-panel" [title]="'Weather Risk and Travel Advisory'" (close)="handleClose()">

    <div id="weather-risk-detail-main-container" #tripTipsPdfContent class="modal-body-container">
      @if (isLoading) {
        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
          <mat-spinner></mat-spinner>
        </div>
      } @else if (weatherRisk$ | async; as risks) {
        @if (risks.length === 0) {
          <p>No weather risk information available for this trip.</p>
        } @else {
          @for (risk of risks; track $index) {
            <section class="risk-section">
              <h3 class="weather-risk-icon"><mat-icon color="primary">location_on</mat-icon> {{ risk.city }}</h3>
              
              @if (formatTravelPeriod(risk.travelPeriod); as period) {
                <p>
                  <strong>Travel Period:</strong> 
                  {{ period.date }} 
                  <span style="font-size: 0.9em; color: #555;">({{ period.timeRange }})</span>
                </p>
              } @else {
                <p><strong>Travel Period:</strong> {{ risk.travelPeriod }}</p>
              }
              
              <div class="summary-box">
                <h4 class="weather-risk-icon"><mat-icon>summarize</mat-icon> Summary</h4>
                <p>{{ risk.weatherSummary }}</p>
              </div>
              
              <div class="risk-indicator">
                <p><strong>Overall Risk Level:</strong> 
                  <span [ngClass]="getRiskLevelClass(risk.riskLevel)">{{ risk.riskLevel | uppercase }}</span>
                </p>
              </div>

              @if (risk.flightStatus?.hasAirTravel) {
                <div class="flight-status-container">
                  <h4 class="weather-risk-icon">
                    <mat-icon color="primary">flight_takeoff</mat-icon> Flight Information
                  </h4>
                  
                  <div class="flight-details-card">
                    <div class="flight-header">
                      <span class="flight-no">Flight: <strong>{{ risk.flightStatus?.flightNumber }}</strong></span>
                      <span class="flight-badge" [ngClass]="getStepStatusClass(risk.flightStatus?.status ?? '')">
                        {{ risk.flightStatus?.status }}
                      </span>
                    </div>
                    <p class="flight-info-text">{{ risk.flightStatus?.details }}</p>
                  </div>
                </div>
              }

              @if (risk.warnings.length) {
                <h4 class="weather-risk-icon"><mat-icon>warning</mat-icon> Warnings/Advisories</h4>
                <mat-list>
                  @for (warning of risk.warnings; track $index) {
                    <div class="wrapping-item">
                      <li>{{ warning }}</li>
                    </div>
                  }
                </mat-list>
              }

              @if (risk.publicEvents.length) {
                <h4 class="weather-risk-icon"><mat-icon>event</mat-icon> Top Public Events</h4>
                @for (event of risk.publicEvents; track $index) {
                  <div class="event-card">
                    <p><strong>{{ event.name }}</strong></p>
                    <p style="font-size: 0.9em; margin-bottom: 5px;">{{ event.description }}</p>
                    <p style="font-size: 0.85em;">
                      <mat-icon style="font-size: 16px; height: 16px; width: 16px;" color="accent">calendar_today</mat-icon> {{ event.dates }}<br>
                      <mat-icon style="font-size: 16px; height: 16px; width: 16px;" color="accent">place</mat-icon> {{ event.location }}
                    </p>
                  </div>
                }
              }
              
              @if (risk.topRestaurants.length) {
                <h4 class="weather-risk-icon"><mat-icon>restaurant</mat-icon> Top Restaurants</h4>
                <mat-list>
                  @for (restaurant of risk.topRestaurants; track $index) {
                    <mat-list-item>{{ restaurant }}</mat-list-item>
                  }
                </mat-list>
              }

              @if (risk.topPlaces.length) {
                <h4 class="weather-risk-icon"><mat-icon>explore</mat-icon> Top Places to Visit</h4>
                <mat-list>
                  @for (place of risk.topPlaces; track $index) {
                    <mat-list-item>{{ place }}</mat-list-item>
                  }
                </mat-list>
              }

              @if (risk.sources.length) {
                <h4 class="weather-risk-icon"><mat-icon>link</mat-icon> Sources</h4>
                <mat-list>
                  @for (source of risk.sources; track $index) {
                    <mat-list-item>
                      <a [href]="source" target="_blank">{{ source }}</a>
                    </mat-list-item>
                  }
                </mat-list>
              }
              
              <hr *ngIf="$index < risks.length - 1">
            </section>
          }
        }
      }
    </div>

    <ng-container id="weather-risk-footer-container" modalPanelFooter>
      <div id="weather-risk-footer-container-buttons" style="display: flex; justify-content: flex-end;">
        <button mat-raised-button color="primary" (click)="downloadTravelTips()" [disabled]="isLoading" style="margin-right: 12px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            @if (!isLoading) {
              <mat-icon>download</mat-icon>
              <span>Download Travel Tips (PDF)</span>
            } @else {
              <mat-spinner color="accent" diameter="24"></mat-spinner>
              <span>Generating...</span>
            }
          </div>
        </button>
        <button id="weather-risk-footer-button-close" mat-raised-button (click)="handleClose()">Close</button>
      </div>
    </ng-container>
  </modal-panel>
</div>